import {
  postRepresentationModule,
  getRepresentationModule,
} from '../../config/apiSinToken'
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Mandar notificacion de representación a la IFI
 * FECHA: 3-10-2022
 */
export const sendNotification = async (idIFI, idUserB2C, idMipyme) => {
  const data = await postRepresentationModule(
    `api/v1/MiPymes/RequestRepresentation/${idIFI}/${idMipyme}/${idUserB2C}`,
  )
  return data
}
/**
 * AUTHOR: wraudales@ngshn.com
 * DESCRIPTION: Mandar notificacion de representación a la IFI
 * FECHA: 3-10-2022
 */
export const AprobarRechazarRepresentar = async (
  idNotification,
  accept,
  observation,
  iduserb2c,
) => {
  const form = {
    idNotification: idNotification,
    Accept: accept,
    Observation: observation,
    idUserB2C: iduserb2c,
  }
  const data = await postRepresentationModule(
    `api/v1/IFIS/HandleRequestIFI/`,
    form,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Remove reprentatio mipyme
 * FECHA: 3-10-2022
 */
export const removeRepresentationMipyme = async ({
  idMIPYME,
  Observation,
  idUserB2C,
}) => {
  const data = await postRepresentationModule(
    `api/v1/IFIS/remove-representation/${idMIPYME}/${Observation}/${idUserB2C}`,
  )
  return data
}

/**
 * AUTHOR: gdegrandez@ngshn.com
 * DESCRIPTION: Remove reprentatio IFI
 * FECHA: 3-10-2022
 */
export const removeRepresentationIFI = async ({
  idMIPYME,
  Observation,
  idUserB2C,
}) => {
  const data = await getRepresentationModule(
    `api/v1/MiPymes/RemoveIfiByMipyme/${idMIPYME}/${Observation}/${idUserB2C}`,
  )
  return data
}
